<template>
  <div class="login_box">
    <header>
      <img style="margin-right:20px;" src="../../assets/img/layout/logo.png" alt="">
      <h1>浙江省学校体育协会运动员注册与报名系统</h1>
      <div class="info">
        <span class="user_name">欢迎你~{{userInfo.name}}</span>
        <span class="login_out" @click="loginOuts">退出登录</span>
      </div>
    </header>
    <main>
      <section class="register">
        <h1 class="title">注册系统</h1>
        <el-button
          @click="inRegist"
          style="width:200px;background:#1E63B0;box-shadow: 0px 4px 10px 0px #1E63B0;border-radius: 30px;border:none;color:#fff;font-size:16px"
        >点击进入</el-button>
      </section>
      <section class="sign_up">
        <h1 class="title">报名系统</h1>
        <el-button
          @click="signUp"
          style="width:200px;background:#1E63B0;box-shadow: 0px 4px 10px 0px #1E63B0;border-radius: 30px;border:none;color:#fff;font-size:16px"
        >点击进入</el-button>
      </section>
    </main>
  </div>
</template>
<script>
import { loginOut } from "@/api/login";
import { clearSession, getSession,setSession} from "@/utils/storage";
export default {
  data() {
    return {
      userInfo: {}
    };
  },
  methods: {
    // 退出登录
    loginOuts() {
      loginOut({}).then(res => {
        clearSession("userInfo");
        this.$router.replace("/login");
        location.reload();
      });
    },
    // 进入报名系统
    signUp(){
      this.userInfo.matce = 'signUp';
      setSession('userInfo',JSON.stringify(this.userInfo));
      this.$router.push("/");
    },
    // 进入注册系统
    inRegist() {
      this.userInfo.matce = 'regist';
      setSession('userInfo',JSON.stringify(this.userInfo));
      this.$router.push("/");
    },
    // 获取用户信息
    getUserInfo() {
      let userInfo = getSession("userInfo") || null;
      if (!userInfo) return;
      userInfo = JSON.parse(userInfo);
      this.userInfo = userInfo;
    }
  },
  mounted() {
    this.getUserInfo();
  }
};
</script>
<style lang="less" scoped>
.login_box {
  width: 100%;
  height: 100vh;
  min-height: 900px;
  background: url("../../assets/img/login/bg.jpg") no-repeat;
  background-size: cover;
  position: relative;
  > header {
    padding: 46px 20px 0 100px;
    display: flex;
    align-items: center;
    > h1 {
      font-size: 38px;
      color: #fff;
      font-weight: 600;
      flex: 1;
    }
    > .info {
      display: flex;
      align-items: center;
      color: #fff;
      > .user_name {
        margin-right: 40px;
      }
      .login_out {
        width: 80px;
        line-height: 32px;
        text-align: center;
        border: 1px solid #fff;
        border-radius: 2px;
        cursor: pointer;
      }
    }
  }
  > main {
    position: absolute;
    height: 60%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    //   transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    .sign_up,
    .register {
      width: 460px;
      height: 290px;
      background: #fff;
      box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.5);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .title {
        font-size: 30px;
        font-weight: 600;
        margin-bottom: 40px;
        letter-spacing: 2px;
      }
    }
    .register {
      margin-right: 160px;
    }
  }
}
</style>